export const userPermissions = {
  all: [
    'Approve Checks',
    'Hide Dashboard',
    'Request EFS Checks',
    'View Settlements',
    'Rate LTL',
    'Collections Key Reason Manager',
    'Edit Permissions',
  ],
  admin: ['Approve Checks', 'Rate LTL', 'Collections Key Reason Manager'],
  agent: [
    'Hide Dashboard',
    'Request EFS Checks',
    'View Settlements',
    'Edit Permissions',
  ],
  it: [
    'Approve Checks',
    'Hide Dashboard',
    'Request EFS Checks',
    'View Settlements',
    'Rate LTL',
    'Collections Key Reason Manager',
    'Freight Matching',
    'Edit Permissions',
  ],
};

export const userAdjustmentTypes = [
  '1110 - AR-Collections/Claims',
  '1220 - Due From Agent',
  '2010 - Garnishments',
  '2040 - Claims & Legal Accrual',
  '5720 - Claims Expense',
  '5800 - Sales Commission',
  '5810 - Agent Sign On Bonus',
  '6020 - Advertising / Marketing',
  '6380 - Dues & Subscriptions',
  ' 6450 - Internet Tools', // this extra space is in the backend as well. maintaining for compatibility
  '6455 - Load Board Expense',
  '6780 - Software Expense',
];

export const adjustmentRecurrenceOptions = ['One Time', 'Recurring'];

export const adjustmentCadenceOptions = [
  'Weekly',
  'Bi-Weekly',
  'Monthly',
  'Quarterly',
  'Annually',
];
